import React from 'react';
import Hero from '../components/ui/Hero';
import BookingModule from '../components/booking/BookingModule';
import ContentSections from '../components/ui/ContentSections';

const Home = () => {
  return (
    <div className=" mx-auto">
      {/* Hero Section */}
      <div className="relative w-[1100px] mx-auto">
        <Hero />
      </div>
      
      {/* Booking Module */}
      <div className="relative max-w-[1010px] mx-auto -mt-[230px]">
        <BookingModule />
      </div>
      
      {/* Content Sections */}
      <ContentSections />
    </div>
  );
};

export default Home;
